import type { InputFormatter } from "../types";

/**
 * Plain text formatter - no transformation, direct pass-through.
 */
export const plainFormatter: InputFormatter = {
  format: (value) => value,
  parse: (input) => input,
};
